import React, { Component } from "react";
import domain from ".././../../../domain";
import axios from "axios";

import { Button } from "mdbreact";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "mdbreact";
export default class SessionWiseFeedbackReport extends Component {
  constructor() {
    super();
    this.state = {
      feedback: null,
      total_trainees: null,
      total_feedback_trainees: null,
      total_trainees_not_given_feedback: null,
      modal: false,
      modal1: false,
    };
  }
  componentDidMount() {
    this.getSessionwiseFeedback();
    this.getTotalTrainees();
    this.getSubmittedFeedbackCount();
    this.getNotSubmittedTraineeDetails();
  }
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  toggle1 = () => {
    this.setState({
      modal1: !this.state.modal1,
    });
  };

  getSessionwiseFeedback() {
    let id = this.props.session;
    console.log(id);
    axios
      .get(`${domain.DBServer}/fetch-session-feedback/${id}`)
      .then((result) => {
        this.setState({ feedback: result.data });
      })
      .catch((err) => console.log(err));
  }

  async getTotalTrainees() {
    let result = await axios.get(
      `${domain.DBServer}/fetch-total-trainees/${this.props.course_id}`
    );
    this.setState({
      total_trainees: result.data[0].count,
    });
  }

  async getSubmittedFeedbackCount() {
    let result = await axios.get(
      `${domain.DBServer}/fetch-total-feedbacks-by-sessions/${this.props.session}`
    );
    this.setState({
      total_feedback_trainees: result.data[0].count,
    });
  }

  async getNotSubmittedTraineeDetails() {
    let result = await axios.get(
      `${domain.DBServer}/fetch-total-trainees-not-given-feedback/${this.props.session}/${this.props.course_id}`
    );
    this.setState({
      total_trainees_not_given_feedback: result.data,
    });
  }

  render() {
    const feedback = this.state.feedback;
    let names;
    let totalavg = 0;
    let totalrows = 0;
    if (feedback) {
      feedback.map((response, key) => {
        {
          let avg =
            (parseInt(response.feedback.clarity, 10) +
              parseInt(response.feedback.objective, 10) +
              parseInt(response.feedback.learning, 10) +
              parseInt(response.feedback.faculty, 10) +
              parseInt(response.feedback.demonstration, 10) +
              parseInt(response.feedback.overall, 10)) /
            6;
          totalrows = totalrows + 1;
          totalavg += avg;
          return true;
        }
      });
    }
    if (this.state.total_trainees_not_given_feedback) {
      names = this.state.total_trainees_not_given_feedback.map(
        (response, key) => {
          return (
            <div key={key}>
              {" "}
              {key + 1}. {response.name}
            </div>
          );
        }
      );
    }
    return (
      <div>
        {/* <button type="button" className="btn btn-info btn-secondary" data-toggle="modal" data-target="#myModal">Summary</button> */}

        {/* <div id="myModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
            
               
                <div className="modal-content">
                  <div className="modal-header">
                   
                    <h4 className="modal-title">Feedback Summary of {this.props.session_title}</h4>
                  </div> */}
        <Button color="primary" onClick={this.toggle}>
          Summary
        </Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg">
          <ModalHeader toggle={this.toggle}>
            Feedback Summary of {this.props.session_title}
          </ModalHeader>
          <ModalBody>
            <div className="modal-body" style={{ fontFamily: "Helvetica" }}>
              <p>Average feedback: {Number(totalavg / totalrows).toFixed(2)}</p>
              <br />
              <p>Total number of participants: {this.state.total_trainees}</p>
              <br />
              <p>
                Total number of feedbacks submitted:{" "}
                {this.state.total_feedback_trainees}
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
        <Button color="primary" onClick={this.toggle1}>
          Feedback Not Given
        </Button>
        <Modal isOpen={this.state.modal1} toggle={this.toggle1} size="lg">
          <ModalHeader toggle={this.toggle1}>
            Feedback Not Given for {this.props.session_title}
          </ModalHeader>
          <ModalBody>
            <div className="modal-body" style={{ fontFamily: "Helvetica" }}>
              {names}
              <br />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle1}>
              Close
            </Button>{" "}
          </ModalFooter>
        </Modal>
        {/* <div className="modal-footer">
                    <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                  </div>
                </div>
            
              </div>
            </div> */}
      </div>
    );
  }
}
